import styled from "styled-components";

export const SidebarContainer = styled.aside<{ $isOpen: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 2px 0 24px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  z-index: 999;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-right: 1px solid #e8eaed;

  @media (max-width: 1024px) {
    transform: translateX(${(props) => (props.$isOpen ? "0" : "-100%")});
    box-shadow: ${(props) => (props.$isOpen ? "4px 0 24px rgba(0, 0, 0, 0.15)" : "none")};
  }
`;

export const SidebarHeader = styled.div`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e8eaed;
  background: #ffffff;
  flex-shrink: 0;
`;

export const MenusWrapper = styled.div`
  flex: 0 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const Logo = styled.div`
  width: auto;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .material-icons {
    color: #ffffff;
    font-size: 26px;
  }
`;

export const LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
  background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
`;

export const MenuSection = styled.div`
  padding: 12px 12px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const MenuTitle = styled.h3`
  font-size: 10px;
  font-weight: 700;
  color: #80868b;
  letter-spacing: 0.5px;
  margin: 0 0 8px 10px;
  text-transform: uppercase;
`;

export const MenuItem = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 2px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  background: ${(props) => (props.$active ? "linear-gradient(90deg, #e8f0fe 0%, #f1f8ff 100%)" : "transparent")};
  color: ${(props) => (props.$active ? "#1967d2" : "#5f6368")};
  font-weight: 600;
  font-size: 13px;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  
  ${(props) => props.$active && `
    box-shadow: 0 2px 8px rgba(25, 103, 210, 0.12);
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 60%;
      background: linear-gradient(180deg, #4285f4 0%, #1967d2 100%);
      border-radius: 0 4px 4px 0;
    }
  `}

  &:hover {
    background: ${(props) => (props.$active 
      ? "linear-gradient(90deg, #e8f0fe 0%, #f1f8ff 100%)" 
      : "linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%)")};
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 1024px) {
    padding: 10px 12px;
    margin-bottom: 2px;
  }
`;

export const MenuIcon = styled.span`
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const MenuLabel = styled.span`
  font-size: 12px;
  flex: 1;
  line-height: 1.2;
  word-break: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const MenuBadge = styled.span`
  background: linear-gradient(135deg, #ea4335 0%, #d23021 100%);
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 12px;
  min-width: 22px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(234, 67, 53, 0.3);
`;

export const SidebarFooter = styled.div`
  padding: 12px 12px;
  border-top: 1px solid #e8eaed;
  background: transparent;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 1px solid #e8eaed;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: linear-gradient(135deg, #f1f3f4 0%, #f8f9fa 100%);
    border-color: #dadce0;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
`;

export const UserAvatar = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4285f4 0%, #34a853 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  box-shadow: 0 3px 10px rgba(66, 133, 244, 0.25);
  flex-shrink: 0;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    inset: -2px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4285f4, #34a853);
    z-index: -1;
    opacity: 0.2;
  }
`;

export const UserInfo = styled.div`
  flex: 1;
  overflow: hidden;
  min-width: 0;
`;

export const UserName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #202124;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
`;

export const UserEmail = styled.div`
  font-size: 12px;
  color: #5f6368;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LogoutButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 16px;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  color: #5f6368;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #f1f3f4 100%);
    color: #ea4335;
    border-color: #ea43351a;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(234, 67, 53, 0.12);
  }

  &:active {
    transform: translateY(0);
  }

  .material-icons {
    font-size: 20px;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 1001;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e8eaed;
  padding: 0;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  &:hover {
    background: #f8f9fa;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(0, 0, 0, 0.1);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }

  .material-icons {
    font-size: 24px;
    color: #202124;
    transition: color 0.2s ease;
  }

  @media (max-width: 1024px) {
    display: flex;
  }

  @media (max-width: 768px) {
    top: 12px;
    left: 12px;
    width: 44px;
    height: 44px;
    
    .material-icons {
      font-size: 22px;
    }
  }
`;

export const Overlay = styled.div<{ $isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, ${(props) => (props.$isOpen ? "0.5" : "0")});
  backdrop-filter: ${(props) => (props.$isOpen ? "blur(4px)" : "blur(0)")};
  z-index: 998;
  opacity: ${(props) => (props.$isOpen ? "1" : "0")};
  visibility: ${(props) => (props.$isOpen ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-tap-highlight-color: transparent;

  @media (max-width: 1024px) {
    display: block;
  }
`;
